import { Button } from '@mui/material';
import styled from 'styled-components';
import { carInfoModalAtom, selectedCenterAtom, selectedPlanCarListAtom } from '@/commons/constants';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import { PlanCar } from '@/types/plan';
import { useEffect, useState } from 'react';
import { planCarListAtom } from '@/interfaces/plan/manage';
import { DataGrid, GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import * as _ from 'lodash';
import { ClearIcon } from '@mui/x-date-pickers/icons';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import CarInfo from './CarInfo';
import { CustomCard } from '../../common/CustomMui';

export default function CarList() {
  return <MainContent />;
}

const MainContentWrap = styled.div`
  width: 100%;
  height: 100%;
  flex-grow:1;
  display:flex;
  flex-direction: column;
  .body{
    padding:0;
    width: 100%;
    flex-grow:1
  }
`;

const FilterArea = styled.div`
  width: 100%;
  display:flex;
  justify-content: flex-end;
  gap: 0.5rem;
  padding-bottom: 0.5rem;
`;

const MainContent = () => {
  const { data: carList } = useAtomValue(planCarListAtom);

  const [selectedPlanCarList, setSelectedPlanCarList] = useAtom(selectedPlanCarListAtom);
  const selectedCenter = useAtomValue(selectedCenterAtom);

  const setCarInfoModal = useSetAtom(carInfoModalAtom);

  const [contents, setContents] = useState<any[]>();

  const [modifyList, setModifyList] = useState<PlanCar[]>([]);
  const [modalInfo, setModalInfo] = useState<PlanCar>();

  const column: GridColDef[] = [
    { field: 'center_name', headerName: '센터', width: 100, headerAlign: 'center', align: 'center' },
    { field: 'name', headerName: '차량명', flex: 1, headerAlign: 'center' },
    { field: 'region', headerName: '권역', width: 100, headerAlign: 'center', align: 'center' },
    { field: 'v_work_time', headerName: '운행시간', width: 110, headerAlign: 'center', align: 'center' },
    {
      field: 'lunch_time',
      headerName: '점심시간',
      width: 70,
      headerAlign: 'center',
      align: 'center',
      renderCell: (param?: GridRenderCellParams<any, string[]>) => {
        return (
          <div
            style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
          >
            {param.value === null || param.value[0] === param.value[1] ? (
              <ClearIcon htmlColor="#d77" />
            ) : (
              <DoneAllIcon htmlColor="#7a7" />
            )}
          </div>
        );
      },
    },
    {
      field: 'start_type',
      headerName: '출발지',
      width: 80,
      headerAlign: 'center',
      align: 'center',
      valueFormatter: (value?: number) => {
        switch (value) {
          case 1:
            return '차고';
          case 0:
          default:
            return '센터';
        }
      },
    },
    {
      field: 'end_type',
      headerName: '종착지',
      width: 80,
      headerAlign: 'center',
      align: 'center',
      valueFormatter: (value?: number) => {
        switch (value) {
          case 0:
            return '센터';
          case 1:
            return '마지막 배송지';
          case 2:
            return '차고';
          default:
            return '-';
        }
      },
    },
    { field: 'v_volume', headerName: '체적', width: 60, headerAlign: 'center', align: 'center' },
  ];

  useEffect(() => {
    if (selectedCenter > -1) {
      if (carList && carList.length > 0) {
        const filterdCarList = _.filter(carList, ['center_seq', selectedCenter]);
        const temp = _.sortBy(filterdCarList, 'name').map((item: PlanCar) => {
          return {
            ...item,
            id: item.seq,
            v_work_time: item.start_time + ' ~ ' + item.end_time,
            v_volume: item.min_volume + ' ~ ' + item.max_volume,
          };
        });
        setContents(temp);
      }
    } else {
      setContents([]);
    }
  }, [selectedCenter, carList]);

  useEffect(() => {
    if (modifyList.length > 0 && modalInfo && modifyList[0] !== modalInfo) {
      const temp = _.map(contents, (item) => {
        const target = _.find(modifyList, ['id', item.id]);
        if (target) {
          return {
            ...target,
            region: modalInfo.region,
            start_time: modalInfo.start_time,
            end_time: modalInfo.end_time,
            start_type: Number(modalInfo.start_type),
            end_type: Number(modalInfo.end_type),
            min_volume: modalInfo.min_volume,
            max_volume: modalInfo.max_volume,
            lunch_time: modalInfo.lunch_time,
            v_work_time: modalInfo.start_time + ' ~ ' + modalInfo.end_time,
            v_volume: modalInfo.min_volume + ' ~ ' + modalInfo.max_volume,
          };
        } else {
          return item;
        }
      });
      setContents(temp);
      if (selectedPlanCarList && selectedPlanCarList.length > 0) {
        const selectedTemp = _.intersectionBy(temp, selectedPlanCarList, 'id');
        setSelectedPlanCarList(selectedTemp);
      }
    }
  }, [modalInfo]);

  const handleSelectionModelChange = (val: any) => {
    const temp = val.map((item: number) => {
      return { id: item };
    });
    const target = _.intersectionBy(contents, temp, 'id');
    setSelectedPlanCarList(target);
  };

  const handleSelectModifyClick = () => {
    setModifyList(selectedPlanCarList);
    const target =
      selectedPlanCarList.length > 0
        ? {
            ...selectedPlanCarList[0],
            name: selectedPlanCarList.length + '대',
            cargo: _.find(selectedPlanCarList, (v) => v.cargo_seq === null) ? true : false,
          }
        : selectedPlanCarList[0];
    setModalInfo(target);
    setCarInfoModal(true);
  };
  const handleRowClick = (item: PlanCar) => {
    setModifyList([item]);
    setModalInfo({ ...item, cargo: item.cargo_seq === null ? true : false });
    setCarInfoModal(true);
  };

  return (
    <CustomCard title={'차량'}>
      <>
        <MainContentWrap>
          <FilterArea>
            <Button
              disabled={selectedPlanCarList.length === 0}
              size="small"
              variant="contained"
              color="info"
              onClick={handleSelectModifyClick}
            >
              선택수정
            </Button>
          </FilterArea>
          <div className="body">
            <DataGrid
              checkboxSelection
              disableColumnResize
              disableRowSelectionOnClick
              columns={column}
              onRowClick={(e) => handleRowClick(e.row)}
              rows={contents ?? []}
              onRowSelectionModelChange={(val) => handleSelectionModelChange(val)}
            />
          </div>
        </MainContentWrap>
        <CarInfo target={modalInfo} setInfo={setModalInfo} />
      </>
    </CustomCard>
  );
};
